// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n@media screen and (max-width: 376px) {\n.chart[data-v-4b7f5c76]{\n      width: 700px !important;\n}\n}\n", ""]);
// Exports
module.exports = exports;
